var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDbsIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 11,
  height: 13,
  fill: "none",
  viewBox: "0 0 11 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m10.854 3.646-3.5-3.5A.5.5 0 0 0 7 0H1a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V4a.5.5 0 0 0-.146-.354M7.5 1.706 9.293 3.5H7.5zM10 12H1V1h5.5v3a.5.5 0 0 0 .5.5h3zM7.154 8.947a2.253 2.253 0 1 0-.707.707l.7.7a.5.5 0 0 0 .707-.708zM4 7.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0"
})));
export { SvgDbsIcon as ReactComponent };
export default __webpack_public_path__ + "3278356ad4331eac680b059167606aec.svg";